import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
	return Cookies.get(TokenKey)
}

export function setToken(token) {
	return Cookies.set(TokenKey, token)
}

export function removeToken() {
	return Cookies.remove(TokenKey)
}

export function getStorageToken() {
	return window.localStorage.getItem(TokenKey);
}

export function setStorageToken(token) {
	return window.localStorage.setItem(TokenKey, token)
}

export function removeStorageToken() {
	return window.localStorage.removeItem(TokenKey)
}

export function isWeiXin() { //判断是否是微信环境
	var ua = window.navigator.userAgent.toLowerCase();
	if(ua.match(/MicroMessenger/i) == 'micromessenger') {
		return true;
	} else {
		return false;
	}
}
